import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/lllustrations/masukan_&_saran.png'
import _imports_1 from '@/app/ui/layout/sidebar/lllustrations/review.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "Sisa saldo"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-x-4 justify-between"
}
const _hoisted_3 = {
  class: "flex flex-col text-xs gap-y-1",
  style: {"font-size":"9px"}
}
const _hoisted_4 = { class: "flex items-center gap-x-1" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "absolute right-0 top-1/2 transform -translate-y-1/2 z-10 h-full opacity-20" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-full h-full",
    alt: "Sisa saldo"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.eligibleShowPopupFeedback)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: `${_ctx.isCollapsed ? 'px-3' : 'px-4'}`
      }, [
        _withDirectives(_createVNode("div", {
          class: ["text-white rounded-lg p-1.5 flex items-start gap-x-1 w-full relative", {
        'justify-center': _ctx.collapse
      }],
          style: {"background-color":"#0FA392"}
        }, [
          _hoisted_1,
          (!_ctx.collapse)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("feedback.titleV2")), 1)
                  ]),
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("feedback.subtitleV2")), 1)
                ]),
                _hoisted_7,
                _createVNode("button", {
                  class: "py-1.5 px-2 rounded-md text-black-lp-300 bg-white z-20",
                  style: {"font-size":"11px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOpenReview && _ctx.onOpenReview(...args)))
                }, _toDisplayString(_ctx.$t("feedback.rate")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2), [
          [_directive_tooltip, _ctx.collapse ? 'Berikan Penilaian Anda' : undefined]
        ])
      ], 2))
    : _createCommentVNode("", true)
}